import { Injectable } from '@angular/core';
import { APIService } from './api.service';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { MessageService } from 'primeng/api';
import { Privileges } from '../core/Models/enums';
import { MessageManagerService } from './messagemanagerService.service';
import { IdleService } from './idel.service';
import { SESSION_LANG_KEY, LANGUAGE_FILE_URLS_KEY, USER_PREF_LANG_KEY, LANG_STORAGE_KEY } from '../core/Models/language.model';

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    private userSubject = new BehaviorSubject<any>(null);
    private sessionExpiredSubject = new BehaviorSubject<boolean>(false);
    public sessionExpired$ = this.sessionExpiredSubject.asObservable();
    
    favourites = [];
    favouriteIds = [];
    public _isPinChanged: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    wallletID: number = 0;
    userName = '';

    constructor(
        private apiService: APIService,
        private router: Router,
        private messageService: MessageManagerService,
        private idleService: IdleService
    ) {}

    public isAuthenticated(): boolean {
        const token: any = localStorage.getItem('token');

        return !(token == null);
    }
    public isPinChanged(): Observable<boolean> {
        return this._isPinChanged.asObservable();
    }
      public setIsPinChanged(status: boolean): void {
        this._isPinChanged.next(status); // Updates the value
    }

    public getNewWallletId(): number {
        return this.wallletID;
    }

    public setNewWallletId(id: number): void {
        this.wallletID = id; // Updates the value
    }

    login(payload: Object) {
        return this.apiService.post('/AuthCoreIntegrator/login', payload)
    }

    loginAfterOtp(payload: Object) {
        return this.apiService.post('/AuthCoreIntegrator/loginafterotp', payload)
    }



    public initLoggedInUser() {
        let userStringified: any = localStorage.getItem('userData');
        if (!this.isAuthenticated() || userStringified == null) {
            this.redirectTo('/auth/sign-in');
        }

        let user = JSON.parse(userStringified);
        this.userSubject.next(user);
    }

    public hasPrivilege(requiredPrivilege: Privileges): Observable<boolean> {
        return this.getCurrentUser().pipe(
            map((user) => {
                const privileges = user.privileges;
                return privileges.includes(requiredPrivilege);
            })
        );
    }

    public redirectTo(route: any) {
        this.router.navigate([route]);
    }

    public getUserToken() {
        const token = localStorage.getItem('token');

        return token;
    }

    public logout(reason?: string) {
        localStorage.removeItem("token");
        localStorage.removeItem("userData");
        localStorage.removeItem("company-accounts");
        localStorage.removeItem("sessionTimeOutMinutes");
        localStorage.removeItem("Privileges");
        localStorage.removeItem("interOpAliasCreated");

        // Set session expired state if logout is due to session timeout
        if (reason === 'session_expired') {
            this.sessionExpiredSubject.next(true);
        }
        
        this.userSubject.next(null);
        this.redirectTo('/auth/sign-in');
    }
    
    // Method to reset session expired state
    public resetSessionExpired() {
        this.sessionExpiredSubject.next(false);
    }

    public getCurrentUser(): Observable<any> {
        if (!this.userSubject || this.userSubject.getValue() === null) {
            this.initLoggedInUser();
        }
        return this.userSubject.asObservable();
    }

    getOtpOnEmail(payload:any) {
        return this.apiService.post(
            `/AuthCoreIntegrator/generateotp`,
            payload
        );
    }
    generateOtpForEmail(request: any) {
        return this.apiService.post(
            '/UserManagementCoreIntegrator/generateOtpForEmail',
            request
        );
    }
    generateOtpForMsisdn(request: any) {
        return this.apiService.post(
            '/UserManagementCoreIntegrator/generateOtpForMsisdn',
            request
        );
    }
    sendOtpForLogin(payload: any) {
        return this.apiService.post(
            `/AuthCoreIntegrator/sendotpforlogin`,
            payload
        );
    }

    getAllOtpConfigs() {
        return this.apiService.get(`/ConfigurationCoreIntegrator/getallotpconfigs`);
    }
    verifyPhoneOtp(payload: any) {
        return this.apiService.post(`/UserManagementCoreIntegrator/VerifyPhoneOtp`, payload);
    }
    verifyOtp(payload: any) {
        return this.apiService.post(`/AuthCoreIntegrator/verifyotp`, payload);
    }
    verifyEmailOtp(payload: any) {
        return this.apiService.post(
            `/AuthCoreIntegrator/verifyEmailOtp`,
            payload
        );
    }

    verifyDetails(payload: any) {
        return this.apiService.post(
            `/AuthCoreIntegrator/verifydetails`,
            payload
        );
    }

    resetPassword(payload: any) {
        return this.apiService.post(
            `/AuthCoreIntegrator/resetpassword`,
            payload
        );
    }

    updateNewUserPassword(payload: any) {
        return this.apiService.post(
            `/AuthCoreIntegrator/updatenewuserpassword`,
            payload
        );
    }
}
